import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { OnyxEvent } from '../../models/event';
import { Rsvp } from '../../models/rsvp';
import { Observable } from 'rxjs/Observable';
import { Reservation, TransientReservation } from '../../models/reservation';
import { LogLevel, LogMessage, LogService } from '../../../shared/log/log.service';
import { TransientReservationStore } from '../../service/transient-reservation-store';
import { of } from 'rxjs/observable/of';
import { ConfirmationModalComponent } from '../../../shared/confirmation-modal/confirmation-modal.component';
import { FlashMessagesService } from '../../../shared/flash-messages/service/flash.messages.service';
import { Page } from '../../../shared/models/page';
import { PaymentStore } from '../../service/payment.store';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationModalConfig } from '../../../shared/confirmation-modal/confirmation-modal-config';

@Component({
  selector: 'pioneer-transient-table',
  templateUrl: './transient-table.component.html'
})
export class TransientTableComponent implements OnInit {

  @Input()
  public event: OnyxEvent;

  @Input()
  public rsvp: Rsvp;

  @Input()
  public isSelectable: boolean;

  public transientReservationSelected: TransientReservation;

  public doNotPay: boolean;

  @ViewChild('confirmLinkModal')
  public confirmLinkModal: ConfirmationModalComponent;

  confirmationModalConfig = new ConfirmationModalConfig();

  @Output()
  public updatePage: EventEmitter<{page: number, itemsPerPage: number}> = new EventEmitter<{page: number, itemsPerPage: number}>();

  @Input()
  searchResults: Page<TransientReservation>;

  public hasPayments = false;

  constructor(private logService: LogService,
              private transientReservationStore: TransientReservationStore,
              private flashMessagesService: FlashMessagesService,
              private paymentStore: PaymentStore,
              private translateService: TranslateService) { }

  ngOnInit() {
    this.paymentStore.getLatestFinalPayment()
      .take(1)
      .subscribe(lastFinalPayment => {
        this.hasPayments = Boolean(lastFinalPayment && lastFinalPayment.eventPaymentId);
      });
  }

  obtainTransientReservationSelected(): Observable<TransientReservation> {
    let result$: Observable<TransientReservation> = new Observable<TransientReservation>();
    if (this.transientReservationSelected) {
      result$ = of(this.transientReservationSelected);
    } else {
      result$ = of(this.searchResults.content[0]);
    }
    return result$;
  }

  onSelect(selectedItem: any) {
    this.logService.log(new LogMessage(LogLevel.DEBUG, `Selected item Id: ${selectedItem.confirmation}`));
    if (this.transientReservationSelected) {
      this.transientReservationSelected.selected = false;
    }
    this.transientReservationSelected = selectedItem;
    this.transientReservationSelected.selected = true;
  }

  cleanSelected() {
    this.transientReservationSelected = undefined;
  }

  confirmBeforeLink(event: any, reservation: TransientReservation, doNotPay: boolean) {
    event.preventDefault();
    if (!this.hasPayments) {
      this.transientReservationSelected = reservation;
      this.doNotPay = doNotPay;
      this.confirmationModalConfig.confirm = this.doNotPay ?
        this.translateService.instant('EVENT.TRANSIENT_RESERVATION.LINK_RESERVATION_TO_EVENT_AND_NOT_PAY') :
        this.translateService.instant('EVENT.TRANSIENT_RESERVATION.LINK_RESERVATION_TO_EVENT_AND_PAY');

      this.confirmLinkModal.open();
    }
  }

  confirmLinkHandler(linkConfirmed: boolean) {
    if (linkConfirmed) {
      this.linkReservation(this.transientReservationSelected);
    }
    this.transientReservationSelected = null;
  }

  linkReservation(reservation: TransientReservation): Observable<Reservation> {
    const page = this.searchResults.number;
    const itemsPerPage = this.searchResults.size;
    this.logService.log(new LogMessage(LogLevel.DEBUG, `Linking item Id: ${reservation.confirmation} - Not pay: ${this.doNotPay}`));
    const $obs = this.transientReservationStore.linkTransientReservationToEvent(reservation.eventReservationId, this.event.eventId,
      this.doNotPay);
    $obs.subscribe(() => {
      this.flashMessagesService.success('MESSAGES.SUCCESS.TRANSIENT_RESERVATION_LINKED');
      this.updatePage.emit({page, itemsPerPage});
    });
    return $obs;
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/reservations/transient-table/transient-table.component.ts